<template>
  <span class="vcl-pill" :style="widgetStyles">
    <slot>{{ pillText }}</slot>
  </span>
</template>

<script>
export default {
  name: 'Pill',
  props: {
    pillText: { type: String, default: '' },
    styles: { type: Object, default: () => ({}) },
  },
  computed: {
    widgetStyles() {
      const styles = {
        '--pill-background': '#016699',
        '--pill-border-radius': '26px',
        '--pill-color': '#FFFFFF',
        '--pill-font-size': '.75em',
        '--pill-font-weight': '600',
        '--pill-padding': '2px 12px',
      }
      return styles;
    }
  }
};
</script>

<style lang="scss" scoped>
.vcl-pill {
  line-height: 16px;
  background: var(--pill-background);
  border-radius: var(--pill-border-radius);
  color: var(--pill-color);
  font-size: var(--pill-font-size);
  font-weight: var(--pill-font-weight);
  padding: var(--pill-padding);
}
</style>
